export default __webpack_public_path__ + "static/media/messages.93e7f591.svg";